// extracted by mini-css-extract-plugin
export default {"component":"QuillDisplayer_component__W6A-w"};